import React from 'react'
import DailyListSection from 'src/sections/DailyListSection'
import RandomList from 'src/sections/RandomList'
import ListSearch from 'src/sections/ListSearch'
import { List, ListItem } from 'src/api/types/lists'
import { GameSounds } from 'src/ui/sound/types'
import { UserSoloStats } from 'src/api/types/users'

export type DashboardTriviaTabViewProps = {
  selectedListTab: string
  dailyList?: List
  soloStats?: UserSoloStats
  fullScreen: boolean
  mode: 'single' | 'multi' | 'host' | undefined
  multiMode: string
  onStartGame: (listId?: number) => void
  onStartRandomList: () => void
  onStartRandomPoll: () => void
  onStartDailyPoll: () => void
  onStartPreviousPoll: () => void
  onNavigateTab?: (tab: 'random' | 'find' | 'polls') => void
  onSelectList: (listId: number | undefined, prompt?: string, items?: ListItem[]) => void
  onEditList?: (list: List) => void
  userId?: number
  showMine?: boolean
  onShowMine?: (value: boolean) => void
  sounds?: GameSounds
}

const DashboardTriviaTabView: React.FC<DashboardTriviaTabViewProps> = ({
  selectedListTab,
  dailyList,
  soloStats,
  fullScreen,
  mode,
  multiMode,
  onStartGame,
  onStartRandomList,
  onStartRandomPoll,
  onStartDailyPoll,
  onStartPreviousPoll,
  onNavigateTab,
  onSelectList,
  onEditList,
  userId,
  showMine,
  onShowMine,
  sounds,
}) => {
  if (selectedListTab === 'daily') {
    return (
      <DailyListSection
        dailyList={dailyList}
        soloStats={soloStats}
        userId={userId}
        fullScreen={fullScreen}
        mode={mode}
        multiMode={multiMode}
        onSelectList={onSelectList}
        onStartGame={() => onStartGame(dailyList?.id)}
        onStartDailyPoll={onStartDailyPoll}
        onStartPreviousPoll={onStartPreviousPoll}
        onNavigateTab={onNavigateTab}
        sounds={sounds}
      />
    )
  }

  if (selectedListTab === 'random') {
    return (
      <RandomList
        fullScreen={fullScreen}
        onStartRandomList={onStartRandomList}
        onStartRandomPoll={onStartRandomPoll}
      />
    )
  }

  if (selectedListTab === 'find') {
    return (
      <ListSearch
        onListSelect={(id, prompt, items) => onSelectList(id, prompt, items)}
        onStartGame={onStartGame}
        showMine={showMine}
        onShowMine={onShowMine}
        userId={userId}
        onEditList={onEditList}
        sounds={sounds}
      />
    )
  }

  return null
}

export default DashboardTriviaTabView
